/* alexander-lige: interacoes globais das secoes clonadas */
(function () {
  // "Sort by" da colecao: navega com ?sort_by= (o facets.js do tema dele nao vem na copia)
  document.addEventListener('change', function (e) {
    var s = e.target.closest('select[data-cl-sort]');
    if (!s) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });
})();

/* before/after (secao before_after do tema dele): arrasta o cursor — mouse e toque (pointer events) —
   e atualiza --clip-path-offset do wrapper, como o script inline dele (que o scope remove) */
(function () {
  var drag = null;
  function clamp(w, v) {
    var pct = parseFloat(getComputedStyle(w).getPropertyValue('--before-after-initial-drag-position')) || 50;
    var base = pct / 100 * w.offsetWidth;
    return Math.max(-base, Math.min(w.offsetWidth - base, v));
  }
  document.addEventListener('pointerdown', function (e) {
    var w = e.target.closest('[class*="cl-"] .before-after-image-wrapper');
    if (!w) return;
    var onCursor = e.target.closest('.before-after__cursor');
    var start = parseFloat(w.style.getPropertyValue('--clip-path-offset')) || 0;
    if (!onCursor) {
      // toque/clique fora do cursor: pula para o ponto (e segue arrastando dali)
      var r = w.getBoundingClientRect();
      var pct = parseFloat(getComputedStyle(w).getPropertyValue('--before-after-initial-drag-position')) || 50;
      start = clamp(w, e.clientX - r.left - pct / 100 * w.offsetWidth);
      w.style.setProperty('--clip-path-offset', start + 'px');
    }
    drag = { w: w, x: e.clientX, o: start };
    e.preventDefault();
  });
  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    drag.w.style.setProperty('--clip-path-offset', clamp(drag.w, drag.o + e.clientX - drag.x) + 'px');
  });
  ['pointerup', 'pointercancel'].forEach(function (t) { document.addEventListener(t, function () { drag = null; }); });
})();
